import { DecimalPipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { PRODUCT_PLACEHOLDER } from 'src/app/app.settings';
import { BasketTableColumns, Product, ProductLine, ProductPackageOption } from 'src/app/models';
import { buttonIcons, symbolIcons } from 'src/app/modules/icon.module';
import { BasketService } from 'src/app/services/basket/basket.service';
import { ProductService } from 'src/app/services/product';
import { IconButtonComponent } from 'src/app/shared/components';
import { CounterComponent } from 'src/app/shared/components/product/counter/counter.component';
import { environment } from 'src/environments/environment';
import { DisplayCurrencyPipe } from '../../../../../shared/pipes/display-currency.pipe';
import { ProductModulePipe } from '../../../../../shared/pipes/module.pipe';
import { PriceSumPipe } from '../../../../../shared/pipes/price-sum.pipe';
import { PrimaryProductImagePipe } from '../../../../../shared/pipes/primary-product-image.pipe';

@Component({
  selector: 'app-basket-overview-item',
  templateUrl: './basket-overview-item.component.html',
  styleUrls: ['./basket-overview-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterLink,
    PrimaryProductImagePipe,
    ProductModulePipe,
    PriceSumPipe,
    DecimalPipe,
    DisplayCurrencyPipe,
    CounterComponent,
    IconButtonComponent,
    MatIconModule,
  ],
})
export class BasketOverviewItemComponent {
  private basketService = inject(BasketService);
  private productService = inject(ProductService);
  cdr = inject(ChangeDetectorRef);

  giftCardUrl = `/${environment.urls.gift_card}`;

  @Input() productLine: ProductLine;
  @Input() columns: BasketTableColumns;
  @Input() simple: boolean;
  @Output() callback = new EventEmitter();

  @Input() @HostBinding('class.error') error = false;

  locale = environment.i18n.language;
  currency = environment.i18n.currency;
  deleteLineIcon = buttonIcons.bigCross;
  multiplyIcon = symbolIcons.delete;
  placeholder = PRODUCT_PLACEHOLDER;

  addProduct(product: Product, quantity: number, packageOptions?: ProductPackageOption[]) {
    this.callback.emit();
    this.basketService.addProduct(product, quantity, packageOptions);
  }

  removeProduct(product: Product, quantity: number, packageOptions?: ProductPackageOption[]) {
    this.callback.emit();
    this.basketService.removeProduct(product, quantity, packageOptions);
  }

  deleteProduct(product: Product) {
    this.callback.emit();
    this.basketService.deleteProduct(product);
  }

  createProductUrl(product: Product) {
    return this.productService.createProductUrl(product);
  }
}
